"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDfootState = void 0;
exports.defaultDfootState = {
    nameFootCaption: 'An Asia Pacific Properties Group Company',
    nameFootLicense: 'EAA Licence Number: C-036846',
    // tslint:disable-next-line:max-line-length
    nameFootCopyright: 'Copyright ©YYYY Okay Property Agency Limited. All rights reserved.',
    // tslint:disable-next-line:max-line-length
    nameFootContact: '15/F, Wilson House, 19-27 Wyndham Street, Central, Hong Kong| T : ',
    nameFootPhone: '+852 2102 0888',
    links: [
        { name: 'About Us', url: '#' },
        { name: 'Contact Us', url: '#' },
        { name: 'Privacy Policy', url: '#' },
        { name: 'Terms and Conditions', url: '#' },
        { name: 'Carrers', url: '#' },
        { name: 'Investors', url: '#' },
    ],
    linkFacebook: 'https://www.facebook.com/OKAYDOTCOM',
    linkInstagram: 'https://www.instagram.com/okay.comhk/',
    linkLinkedIn: 'https://www.linkedin.com/company/okay-com',
    linkYoutube: 'https://www.youtube.com/user/okayproperty',
};
